import script from "./dashMain.vue?vue&type=script&setup=true&lang=js"
export * from "./dashMain.vue?vue&type=script&setup=true&lang=js"

import "./dashMain.vue?vue&type=style&index=0&id=16ccc9e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16ccc9e8"]])

export default __exports__